const STATS = [
  { icon: '🖼️', value: '10,000+', label: 'Generations daily' },
  { icon: '🤖', value: '50+',     label: 'AI models available' },
  { icon: '⚡', value: '99.9%',   label: 'API uptime SLA' },
  { icon: '⭐', value: '5-star',  label: 'Creator experience' },
];

export default function SocialProof() {
  return (
    <section id="trust" style={{ paddingTop: 48, paddingBottom: 48 }}>
      <div className="container">
        <div className="card" style={{ padding: 36, textAlign: 'center', background: 'linear-gradient(180deg, rgba(255,255,255,.04), rgba(255,255,255,.015))' }}>
          <div className="eyebrow" style={{ marginBottom: 18 }}>Trusted by creators worldwide</div>
          <div style={{ fontSize: 22, fontWeight: 600, letterSpacing: '-0.02em', maxWidth: 720, margin: '0 auto', color: 'var(--text-2)' }}>
            <span style={{ color: '#fff' }}>Thousands of creators</span> across the globe build their AI pipelines on <span style={{ color: '#fff' }}>Flux URO</span>.
          </div>
          <div className="row" style={{ marginTop: 36, gap: 20, justifyContent: 'center', flexWrap: 'wrap' }}>
            {STATS.map(s => (
              <div key={s.label} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8, padding: '20px 28px', borderRadius: 16, border: '1px solid var(--border)', background: 'rgba(255,255,255,.03)', minWidth: 140 }}>
                <span style={{ fontSize: 28 }}>{s.icon}</span>
                <span style={{ fontSize: 22, fontWeight: 700, letterSpacing: '-0.02em', color: '#fff' }}>{s.value}</span>
                <span style={{ fontSize: 13, color: 'var(--text-3)' }}>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
